export const state = () => ({
  oneOfFeeUserLocationPasss: [],
})

export const getters = {
  getOneOfFeeUserLocationPasss: (state) => {
    return state.oneOfFeeUserLocationPasss
  },
}

export const mutations = {
  SET_ONE_OF_FEE_USER_LOCATION_PASSS: (state, oneOfFeeUserLocationPasss) => {
    state.oneOfFeeUserLocationPassS = oneOfFeeUserLocationPasss
  },
}

export const actions = {
  setOneOfFeeUserLocationPasss({ commit }, oneOfFeeUserLocationPasss) {
    commit('SET_ONEOFFEEUSERLOCATIONPASSS', oneOfFeeUserLocationPasss)
  },

  async setupOneOfFeeUserLocationPasss({ commit, getters }) {
    if (
      !getters.getOneOfFeeUserLocationPasss ||
      getters.getOneOfFeeUserLocationPasss.length === 0
    ) {
      const r = await this.$axios.$get(`/one-of-fee-user-location-pass`)
      if (!r || !r.data) {
        throw new Error(
          'response format error: error getting oneOfFeeUserLocationPass'
        )
      }
      commit('SET_ONE_OF_FEE_USER_LOCATION_PASSS', r.data)
    }
  },
}
